import { render } from "./teacher-card.vue?vue&type=template&id=1a363e52&ts=true"
import script from "./teacher-card.ts?vue&type=script&lang=ts&external"
export * from "./teacher-card.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__